import Auth from '../api/auth';
import { frontendURL } from './URLHelper';

const ACCESS_LOCK_ERROR_TYPE = 'access_lock_ip_denied';

const parseErrorCode = error => Promise.reject(error);

const redirectToAccessLockedPage = error => {
  const { status, data } = error.response || {};
  if (status !== 403 || data?.error_type !== ACCESS_LOCK_ERROR_TYPE) {
    return;
  }

  const pathParts = window.location.pathname.split('/');
  // /app/accounts/:accountId/...
  const accountsIndex = pathParts.indexOf('accounts');
  const accountId = accountsIndex >= 0 ? pathParts[accountsIndex + 1] : null;
  if (!accountId) return;

  const lockedPath = frontendURL(`accounts/${accountId}/access-locked`);
  if (window.location.pathname.includes('/access-locked')) return;

  window.location.assign(lockedPath);
};

export default axios => {
  const { apiHost = '' } = window.rookooConfig || {};
  const wootApi = axios.create({ baseURL: `${apiHost}/` });
  // Add Auth Headers to requests if logged in
  if (Auth.hasAuthCookie()) {
    const {
      'access-token': accessToken,
      'token-type': tokenType,
      client,
      expiry,
      uid,
    } = Auth.getAuthData();
    Object.assign(wootApi.defaults.headers.common, {
      'access-token': accessToken,
      'token-type': tokenType,
      client,
      expiry,
      uid,
    });
  }
  // Response parsing interceptor
  wootApi.interceptors.response.use(
    response => response,
    error => {
      redirectToAccessLockedPage(error);
      return parseErrorCode(error);
    }
  );
  return wootApi;
};
